export default __webpack_public_path__ + "images/arrow-black-icon.svg?19b2ba2995db0339064b71c052fd2df5";